<template>
  <div>
    <v-form>
      <v-container>
        <v-row>
          <v-col>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="searchDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchDate"
                  label="查詢日期"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchDate"
                :max="maxDate"
                scrollable
                locale="zh-tw"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(searchDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-text-field
            v-model="carId"
            label="車牌(選填)"
          ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
            v-model="ticketId"
            label="單號(選填)"
          ></v-text-field>
          </v-col>
          <v-col>
            <v-btn
              :loading="loading"
              :disabled="loading"
              @click="getUserRecord"
            >
              查詢
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-data-table
      :headers="headers"
      :items="userRecords"
      :search="filter"
      item-key="user_id"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="filter"
            append-icon="mdi-magnify"
            label="Filter"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          操作細節: {{ item.user_content }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: null,
      carId: '',
      ticketId: '',
      searchDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      maxDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      filter: '',
      userRecords: [],
      headers: [
        {
          text: '使用者',
          align: 'start',
          value: 'user_name',
        },
        {
          text: '操作',
          value: 'user_action',
        },
        {
          text: '單號',
          value: 'ticket_gov_id',
        },
        {
          text: '車格',
          value: 'ticket_cell_id'
        },
        {
          text: '時間',
          value: 'created_at',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    }
  },

  computed: {
  },

  watch: {
  },

  methods: {
    getUserRecord() {
      this.loading = true;
      this.axios.get(`api/user/history?beginTime=${this.searchDate}&endTime=${this.searchDate}&carId=${this.carId}&ticketId=${this.ticketId}`)
        .then((resp) => {
          this.userRecords = resp.data;
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },
}
</script>
